(function($) {

    $.fn.msxiSlider = function(options) {
        // build main options before element iteration
        var opts = $.extend( {}, $.fn.msxiSlider.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            if($this.is('.spinner')) {
                // Create a slider to accompany the spinner and keep the values in sync.
                var sliderOpts = $.extend(true, eOpts['slider'], eOpts['spinner'], {
                    value: $this.val(),
                    disabled: $this.is(':disabled') || $this.is('[readonly]'),
                    slide: function(event, ui){
                        $this.val(ui.value);
                    }
                });
                var $slider = $( "<div class='slider'></div>" ).insertBefore($this.parent('.ui-spinner')).msxislider(sliderOpts);

                if(sliderOpts['disabled']) {
                    $slider.msxislider('disable');
                }

                $this.on('spinstop change', function(){
                    $slider.msxislider('value', $this.val());
                });

                $this.on('disabled', function(){
                    $slider.msxislider('disable');
                });

                $this.on('enabled', function(){
                    $slider.msxislider('enable');
                });
            }
            else {
                if($this.is('input')) {
                    var $slider = $('<div>&nbsp;</div>');
                    $slider.attr('id', $this.attr('id'))
                           .attr('name', $this.attr('name'))
                           .attr('class', $this.attr('class'))
                           .attr('title', $this.attr('title'));

                    var sliderOpts = eOpts['slider'];

                    if($this.is(':disabled') || $this.is('[readonly]')) {
                        sliderOpts = $.extend(sliderOpts, {disabled: true});
                    }
                    if($this.val()) {
                        sliderOpts = $.extend(sliderOpts, {value: $this.val()});
                    }

                    $this.replaceWith($slider);

                    var $altField = $('<input type="hidden" />');
                    $altField.attr({
                        'id':$this.attr('id'),
                        'name':$this.attr('name')
                    });
                    $altField.val($this.val());
                    $altField.insertBefore($slider);

                    $slider.msxislider(sliderOpts);

                    $slider.on("msxisliderslide", function(event, ui) {
                        $altField.val(ui.value);
                    });

                    if(sliderOpts['disabled']) {
                        $slider.msxislider('disable');
                    }
                }
                else {
                    $this.msxislider(eOpts['slider']);
                }
            }

        });
    };
    //
    // plugin defaults
    //
    $.fn.msxiSlider.defaults = {
    };

})(jQuery);